/**
 * Initialize the Magic Wand color removal tool
 */

import magicWandManager from './MagicWandManager';

/**
 * Initialize Magic Wand system
 */
export function initMagicWand() {
  // Initialize the manager
  magicWandManager.init();

  console.log('Magic Wand tool initialized');
}

/**
 * Check if Magic Wand is active
 */
export function isMagicWandActive() {
  return magicWandManager.isActive;
}

/**
 * Stop Magic Wand if active
 */
export function stopMagicWand() {
  if (magicWandManager.isActive) {
    magicWandManager.reset();
  }
}
